const LIGHT = "light";
const DARK = "dark";

export { LIGHT, DARK };
